module.exports = __webpack_public_path__ + "img/album_pay@3x.29ea3c85.png";